import { render } from "./getLookups.vue?vue&type=template&id=61e82b4c"
import script from "./getLookups.vue?vue&type=script&lang=js"
export * from "./getLookups.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__